import React, { useEffect, useState } from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { FiHelpCircle } from 'react-icons/fi'
import ReactMarkdown from 'react-markdown'
import BrandIcon from './UI/BrandIcon'
import Popup from './UI/Popup'
import { language } from '../utils'

export default function HelpCenter({ className, showHelp: show, setShowHelp: setShow }) {
  const { strapi } = useStaticQuery(graphql`
    {
      strapi {
        helps {
          answer
          title
          locale {
            language
          }
        }
      }
    }
  `)

  return (
    <>
      <BrandIcon Icon={FiHelpCircle} className={`relative w-10 h-10 ${className}`} onClick={() => setShow(true)} white />
      {show &&
        <Popup title="FAQ" close={() => setShow(false)}>
          <div className="text-left">
            {strapi.helps.filter(h => (h.locale || {}).language === language()).map(({ answer, title }) => (
              <div className="my-4">
                <div className="font-bold">{title}</div>
                <ReactMarkdown className="font-thin">{answer}</ReactMarkdown>
              </div>
            ))}
          </div>
        </Popup>
      }
    </>
  )
}
